import thunk from "redux-thunk";
import rootReducer from "./reducers";
import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { persistStore } from 'redux-persist';

const middleware = [thunk];

const store = configureStore({

  reducer: rootReducer,
}
);

const persistor = persistStore(store);

setupListeners(store.dispatch)

export {store, persistor};
